export default () => window.location.hostname.split('.').slice(-2).join('.');
